import { styled, keyframes } from '@mui/material';

export const pulse = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.3;
  }
`;

export const StarStyled = styled('svg')<{
  pulseDelay: number;
  pulseDuration: number;
  starScale: number;
  left: string;
  top: string;
}>`
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  animation: ${pulse} ${({ pulseDuration }) => pulseDuration}s infinite ease-in-out;
  animation-delay: ${({ pulseDelay }) => pulseDelay}s;
  transform: scale(${({ starScale }) => starScale});
`;
